import { Observable, shareReplay } from 'rxjs';

/** Caché en memoria de un observable HTTP: una petición por ciclo de vida (salvo {@link clear}). */
export interface CachedObservable<T> {
  get(): Observable<T>;
  clear(): void;
}

export function createCachedObservable<T>(factory: () => Observable<T>): CachedObservable<T> {
  let cache$: Observable<T> | undefined;
  return {
    get(): Observable<T> {
      if (!cache$) {
        cache$ = factory().pipe(shareReplay({ bufferSize: 1, refCount: false }));
      }
      return cache$;
    },
    clear(): void {
      cache$ = undefined;
    },
  };
}
